<template>
  <div id="project">
    <HeaderControlsProject :myWeek='false' @filterUpdated='false' @collapseToggleUpdated='false'  :namespace="namespace"/>
    <div class="container-fluid">
      <ProjectList  :namespace="namespace"/>
    </div>
  </div>
</template>
<script>
import HeaderControlsProject from "../components/common/HeaderControlsProject";
import ProjectList from "../components/deliverables/ProjectList";

export default {
  data() {
    return {
    	namespace:""
    }
  },
  components: {
    HeaderControlsProject,
    ProjectList
  }
};
</script>